import { ref } from 'vue';
import { defineStore } from 'pinia';

interface State {
  loading: boolean;
}

const useApplicationStore = defineStore({
  id: 'application',
  state: () => ref<State>({
    loading: false,
  }),
  actions: {
    setLoading(loading: boolean): void {

      this.loading = loading;
      this.toggleLoadingIcon();
    },
    toggleLoadingIcon() {
      const loadingElement: HTMLElement | null = document.getElementById('divProcessing');

      if (!loadingElement) {
        return
      }

      if (this.loading === false) {
        loadingElement.style.display = 'none';
      } else if (this.loading && loadingElement.style.display === 'none') {
        // currently the store is loading and no icon is showing.
        // we want to wait for half a second before displaying
        // the icon. This is so we dont end up with a jarring
        // page shift for content that only takes 200ms to load.
        setTimeout(() => {
          if (this.loading) {
            loadingElement.style.display = 'block';
          }
        }, 500)
      }
    },
  },
});

export default useApplicationStore;
